import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Input } from 'semantic-ui-react';
import styles from './styles.scss';

export const KeywordFilter = (props) => {
  return (
    <Grid>
      <Grid.Column>
        <Input
          icon="search"
          name="test-keyword-filter"
          className={styles['keyword']}
          type="keyword"
          onChange={props.filter}
          value={props.value}
          placeholder="Search..."
        />
      </Grid.Column>
    </Grid>
  );
};

KeywordFilter.propTypes = {
  filter: PropTypes.func.isRequired,
  value: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/components/filter/KeywordFilter.js